"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _numeral = _interopRequireDefault(require("numeral"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routing = require("Functions/Routing");
var _CloseLetter = _interopRequireDefault(require("Icons/CloseLetter"));
var _OpenLetter = _interopRequireDefault(require("Icons/OpenLetter"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ChatRow = _ref => {
  let {
    data,
    blank = false
  } = _ref;
  const role = app.state.session.user.roles[0];
  const screenWidth = window.screen.width;

  /* numeral.locale('en'); */
  _moment.default.locale('fr');
  const blank_props = blank === true ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  const link = /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({
    className: "u-link-only"
  }, blank_props, {
    href: (0, _Routing.URL)('/liste-des-dossiers') + '/' + data.related_project_id
  }), "conversation");
  const formatedDate = (0, _moment.default)(data.content[data.content.length - 1].message_date).format('LLL');
  const pratician = data.__user.firstname + " " + data.__user.name + " / " + data.__user.login;
  let read = '';
  if (role === 'deltex') {
    read = (data === null || data === void 0 ? void 0 : data.read_by_deltex) == true ? /*#__PURE__*/_react.default.createElement(_OpenLetter.default, {
      className: "open-letter-icon"
    }) : /*#__PURE__*/_react.default.createElement(_CloseLetter.default, {
      className: "close-letter-icon"
    });
  }
  if (role === 'pratician') {
    read = (data === null || data === void 0 ? void 0 : data.read_by_pratician) == true ? /*#__PURE__*/_react.default.createElement(_OpenLetter.default, {
      className: "open-letter-icon"
    }) : /*#__PURE__*/_react.default.createElement(_CloseLetter.default, {
      className: "close-letter-icon"
    });
  }
  const readClass = read === 'Non-lu' ? "c-dashboard__cell u-color_red u-fontweight" : "c-dashboard__cell";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__row"
  }, role === "deltex" && screenWidth > 1200 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell "
  }, pratician, link) : undefined, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell "
  }, role === "deltex" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.related_project, link) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.__project.patient_firstname + ' ' + data.__project.patient_lastname, link)), screenWidth > 1200 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "c-dashboard__cell "
  }, formatedDate) : undefined, /*#__PURE__*/_react.default.createElement("div", {
    className: readClass
  }, read));
};
var _default = exports.default = ChatRow;
